import { Select, SelectProps } from "antd";
import React, { useState, useEffect, useRef } from "react";

export interface ISearchSelectProps<T> extends SelectProps<number | string> {
    //value: string | number
    controller: (searchValue: string) => Promise<Array<T>>;
    getKeyValue: (option: T) => string | number | undefined;
    getDS: (option: T) => string | undefined;

    filter?: (options: T) => boolean;
    onOptionsLoad?: (options: Array<T>) => void;
    buscarEmpreendimento?: boolean;
}

export default function SearchSelect<T>(props: ISearchSelectProps<T>) {
    const [lstOptionsNonFiltered, setLstOptionsNonFiltered] = useState<
        Array<T>
    >([]);
    const [lstOptions, setLstOptions] = useState<Array<T>>([]);

    const {
        controller,
        getKeyValue,
        getDS,
        onOptionsLoad,
        filter,
        ...selectProps
    } = props;

    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string) {
        ultimaPesquisaRef.current = searchValue;
        if (searchValue.length >= 3) {
            setTimeout(() => {
                if (ultimaPesquisaRef.current === searchValue) {
                    controller(searchValue).then((res) =>
                        setLstOptionsNonFiltered(res)
                    );
                    //(.then( setLstOptionsNonFiltered ))=>mesma coisa
                    /*
              setLstOptionsNonFiltered(searchValue)
              .then(res =>{
                setLstOptions(res)
              })*/
                }
            }, 1000);
        }
    }

    useEffect(() => {
        setLstOptions(
            filter
                ? lstOptionsNonFiltered.filter(filter)
                : lstOptionsNonFiltered
        );
    }, [lstOptionsNonFiltered, filter]);

    useEffect(() => {
        if (props.buscarEmpreendimento) {
            controller("").then((res) => setLstOptionsNonFiltered(res));
        }
    }, [props.buscarEmpreendimento, controller]);

    useEffect(() => {
        onOptionsLoad?.(lstOptions);
    }, [lstOptions, onOptionsLoad]);

    return (
        <Select
            className="ant-select-custom-input w-100"
            defaultActiveFirstOption={false}
            showArrow
            filterOption={false}
            notFoundContent={null}
            showSearch
            mode={props.mode}
            {...selectProps}
            onSearch={handleSearch}
            // value={props.id}
            //onChange={setIdContato}
        >
            {lstOptions.map((option) => (
                <Select.Option
                    value={`${props.getKeyValue(option)}`}
                    key={props.getKeyValue(option)}
                >
                    {props.getDS(option)}
                </Select.Option>
            ))}
        </Select>
    );
}
